export default [
  {
    key: "placeholder",
    ignore: true,
  }
];